module.exports = __webpack_public_path__ + "img/Frage3_768x1024.b4260e10.jpg";